import React from 'react'
import Modal from 'react-bootstrap/Modal';
import Helpers from '../../Components/Helpers/Helpers';
import Customers from './Customers';

const CustomersList = ({ show, onHide, publicCustomers, onAddCustomers, customersAdded, showButttonAdd, typeList }) => {

    // if (Helpers.date.get({ format: '%Y-%m-%d' }) >= '2026-02-16') {
    //     return <></>
    // }

    return <Modal show={show} onHide={onHide} backdrop="static" size="xl">
        <Modal.Header closeButton>
            <Modal.Title as="div">Seleccionar Clientes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Customers nameSingle={Helpers.string.toCamelCase('Cliente')} namePlural={Helpers.string.toCamelCase('Clientes')} separator={'el'.toLowerCase()} publicCustomers={publicCustomers} onAddCustomers={onAddCustomers} customersAdded={customersAdded} showButttonAdd={showButttonAdd} typeList={typeList} />
        </Modal.Body>
    </Modal>
}

CustomersList.defaultProps = {
    publicCustomers: false,
    onAddCustomers: () => { },
    customersAdded: [],
    showButttonAdd: true
}

export default CustomersList